import { Box, Flex, FormControl, Input, InputGroup, InputRightAddon, Text } from "@chakra-ui/react";

import OtpInput from "./otpInput";
import { Regisration_Form_Labels_English } from "./constants/englishLabels";
import { Regisration_Form_Labels_Hindi } from "./constants/hindiLabels";
import { RootState } from "src/store/store";
import { toCamelCase } from "src/utils/globalUtils";
import { useSelector } from "react-redux"
import { useState } from "react";

interface MobileInputProps {
    setMobileNumber: (value: string) => void;
    mobileNumber: string;
}

export const MobileNumberInput: React.FC<MobileInputProps> = ({ setMobileNumber, mobileNumber }: MobileInputProps) => {
    const [verifyClicked] = useState(false);
    const [isMobileNumberInValid, setIsMobileNumberInValid] = useState(false)

    const globalInfo = useSelector((state: RootState) => state.globalInfo);
    const { globalLanguage } = globalInfo;
    const isHindiLabels = globalLanguage === "HI";

    const validateMobileNumber = (mobileNumber: string) => {
        const input = mobileNumber.replace(/[^0-9]/g, "");
        if (input.length <= 10) {
            if (isMobileNumberInValid) {
                setIsMobileNumberInValid(false)
            }
            setMobileNumber(input);
        }
    };

    const handleOnBlur = () => {
        if (mobileNumber.length === 10) {
            setIsMobileNumberInValid(false);
        }
        else {
            setIsMobileNumberInValid(true);
        }
    };
    return (
        <Flex direction="column" width="100%" gap={4}>
            <FormControl isInvalid={isMobileNumberInValid}>
                <InputGroup borderRadius="0.5rem" background="rgba(108, 117, 125, 0.08)" alignContent="center">
                    <Text alignSelf="center" m="0.5rem">+91</Text>
                    <Box alignSelf="center" height="80%" borderRight="2px solid" />
                    <Input
                        isInvalid={isMobileNumberInValid}
                        textColor={isMobileNumberInValid ? "#E53E3E" : "inherit"}
                        marginLeft="0.5rem"
                        variant="unstyled"
                        onBlur={() => handleOnBlur()}
                        background="transparent"
                        border="1px"
                        boxShadow={isMobileNumberInValid ? "0 0 0 1px #E53E3E" : ""}
                        borderColor={isMobileNumberInValid ? "#E53E3E" : "transparent"}
                        className="form-input"
                        pl={4}
                        type='tel'
                        value={mobileNumber}
                        maxLength={10}
                        placeholder='700398 XXXXX'
                        onChange={(e) => validateMobileNumber(e.target.value)}
                    />
                    <InputRightAddon background="transparent" border="transparent" alignItems="center" justifyContent="flex-end">
                        {/* <Button height="80%" variant="mks" onClick={() => setVerifyClicked(true)}> Verify </Button> */}
                    </InputRightAddon>
                </InputGroup>
                {isMobileNumberInValid && <Text mt={2} color="#E53E3E">{isHindiLabels ? `${Regisration_Form_Labels_Hindi.MOBILE_NUMBER} अमान्य` : `Invalid ${toCamelCase(Regisration_Form_Labels_English.MOBILE_NUMBER)}`}</Text>}
            </FormControl>
            {verifyClicked ?
                <OtpInput
                    length={6}
                    onOtpSubmit={() => { }}
                    verifyClicked={verifyClicked}
                />
                : null
            }
        </Flex>
    );
};
